<template>
    
</template>


<script>
var firebase = require("firebase/app");
require("firebase/messaging");

var messaging = firebase.messaging();

export default {
  async mounted() {
    if (this.$util.getToken() === "") {
      this.$router.push({ name: "home" });
      return;
    }
    const response = await this.$client.logout();
    this.$util.log("logout", response);
    this.$util.clearData();
    this.unregisterFcm();
    this.$router.push({ name: "login" });
  },
  methods: {
    unregisterFcm() {
      messaging
        .getToken()
        .then(function(currentToken) {
          messaging
            .deleteToken(currentToken)
            .then(function() {
              console.log("Token deleted.");
            })
            .catch(function(err) {
              console.log("Unable to delete token. ", err);
            });
        })
        .catch(function(err) {
          console.log("Error retrieving Instance ID token. ", err);
        });
    }
  }
};
</script>
